import { ConnectionStatus } from "./DeviceConnectionStatus";
import { RawWatcherProfile } from "./RawDeviceProfile";
import { WatcherClientInfo } from "./WatcherClientInfo";


export class WatcherProfile
{
    public TrackedDeviceId: string;
    public TrackedDeviceStatus: string;
    public Id: string;
    public Info: WatcherClientInfo;
    public Status: ConnectionStatus;

    constructor(raw: RawWatcherProfile)
    {
        this.TrackedDeviceId = raw.TrackedDeviceId;
        this.TrackedDeviceStatus = raw.TrackedDeviceStatus;
        this.Id = raw.Id;
        this.Info = raw.Info;
        this.Status = raw.Status;
    }
}
